import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Input, Image, message,Modal } from "antd";
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
// import "../verifymail.css";
import "../../../GlobalCss/SPF/Login.css";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import { decrypt } from "../../../Utils/Utils";
import { encodeRoute, routes } from "../../../Utils/Utils";
const VerificationForm = ({ location }) => {
  const [code, setCode] = useState(Array(6).fill(""));
  const [showSpinner, setShowSpinner] = useState(false);
  const inputRefs = useRef([]);
  const history = useHistory();

  const email = Cookies.get("email")
   const tenantName = Cookies.get("tenant_name")
  const url =  `/${tenantName}`

  useEffect(() => {
    const email = Cookies.get("email");
    if (!email) {
      history.replace(`/${tenantName}`);
    }
    // Focus on the first input field initially
    inputRefs.current[0]?.focus();

    const jwtToken = Cookies.get("jwt_token");
    const role= Cookies.get("Role");
    const userRole = decrypt(role);
    const reqRole = "Super User";
    if (jwtToken !== undefined && userRole === reqRole) {
      // window.location.href = `/${tenantName}/${routes.adminDashboard}`;
      window.location.href = `/${tenantName}/admin-dashboard`;
    } else if (jwtToken !== undefined && userRole === "User") {
      // window.location.href = `/${tenantName}/${routes.dashboard}`;
      window.location.href = `/${tenantName}/dashboard`;
    }
  }, []);

  const handleChange = (e, index) => {
    const { value } = e.target;
    if (!/^\d*$/.test(value)) return;
    // Update the value of the current input field
    const updatedCode = [...code];
    updatedCode[index] = value;
    setCode(updatedCode);

    // Move focus to the next input field if the value is not empty
    if (value && index < code.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };


  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      email: email,
      otp: code.join(""),
    };




    setShowSpinner(true);
    axios.post(`${process.env.REACT_APP_BASE_URL}Auth/signin/verify-otp`, data)
      .then((response) => {
        console.log(response)
        setShowSpinner(false);

        if (response.data.isSuccess) {

          onSubmitSuccess(response.data.payload);

        } else if (response.data.statusCode === 403) {
          message.error(`${response.data.message}. Redirecting to login...`);
          Modal.info({
            title: "Access Denied",
            content: "You are locked out. Please try again after 15 minutes.",
            onOk: () => history.replace(`/${tenantName}`),
          });
        }
        else {
          message.error(response.data.message);
        }
      })
      .catch((error) => {
        setShowSpinner(false);
        console.error("Error verifying OTP:", error);

      });
  };

  const onSubmitSuccess = (payload) => {

    const responseData = JSON.parse(payload);


    const jwtToken = responseData.Token;
    const encryptedFirstName = responseData.FirstName;
    const encryptedLastName = responseData.LastName;
    const encryptedRole = responseData.Role;

    Cookies.set("jwt_token", jwtToken);
    Cookies.set("first_name", encryptedFirstName);
    Cookies.set("last_name", encryptedLastName);
    Cookies.set("UserLogin", email);
    Cookies.set("Role", encryptedRole);
    Cookies.remove("email");
const first_name=decrypt(encryptedFirstName)
const last_name=decrypt(encryptedLastName)
const role=decrypt(encryptedRole)
    // Redirect based on role
    if (role === "Super User") {
      // history.replace(`/${tenantName}/${routes.adminDashboard}`);
      window.location.href = `/${tenantName}/admin-dashboard`;

      ActivePage("1");
    }
    else if (role === "Timesheet Coordinator") {
      // history.replace(`/${tenantName}/${routes.timesheetTeam}`);
      history.replace(`/${tenantName}/timesheetteam`);
      ActivePage("timesheetteam");
    }
    else if (role === "Billing Coordinator") {
      // history.replace(`/${tenantName}/${routes.billingData}`);
      history.replace(`/${tenantName}/billing`);
      ActivePage("billing");
    }
    else if (role === "1099 Coordinator") {
      // history.replace(`/${tenantName}/${routes.tenNinetyNineCrawl}`);
      history.replace(`/${tenantName}/1099crawl`);
      ActivePage("20");
    }
    else {
      // history.replace(`/${tenantName}/${routes.dashboard}`);
      window.location.href = `/${tenantName}/dashboard`;
      ActivePage("1");
    }
  };

  // const maskedEmail = `${email.substring(0, 3)}******${email.substring(email.lastIndexOf("@"))}`;
  return (
    <div className="mobile-verification-container">
      <div className="signin-image">
        <Image
          src="/Images/illus3.png"
          style={{
            border: "none",
            width: "90%",
            height: "100%",
          }}
          showPreviewIcon={false}
          preview={false}
        />
      </div>
      <main className="verification-main">
        <div className="verification-content">
          <p style={{ color: "#A0AEFF" }}>An Otp has been sent to <strong style={{ color: "#0024FF" }}>{email}</strong></p>
          <p style={{ color: "#A0AEFF" }}>Please enter the code to confirm your Email</p>
          <div className="verification-card">
            <header className="verification-header">
              <h1 className="verification-title">Email Verification</h1>
              <p className="verification-description">
                Enter the 6-digit verification code that was sent to your Email.
              </p>
            </header>
            <Form id="otp-form" onSubmit={handleSubmit}>
              <div className="verification-inputs">
                {[...Array(6)].map((_, index) => (
                  <Input
                    key={index}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="verification-input"
                    value={code[index]}
                    maxLength={1}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onKeyPress={handleKeyPress}
                    ref={(input) => (inputRefs.current[index] = input)}
                  />
                ))}
              </div>
              <div className="verification-button-container">
                <Button
                  type="button"
                  className="verification-button"
                  disabled={showSpinner}
                  onClick={handleSubmit}

                >
                  {showSpinner ? "Verifying..." : "Verify OTP"}{" "}
                  <ArrowRightOutlined />
                </Button>
              </div>
            </Form>
          </div>
          <h5 style={{ color: "#3B52DF" }}>
            <Link to={`/${tenantName}`}>
              <ArrowLeftOutlined />  Go To Login
            </Link>
          </h5>
        </div>
      </main>
    </div>
  );
};

export default VerificationForm;
